module.exports = __webpack_public_path__ + "img/cartoonHead1-2.0ee95fe0.png";